import EventEmitter from "events";
import { Notification } from "../models/Notification";
import { RoomSetting } from "../models/User";

export class MyNotifs {
  static NotificationsByMessage = new Map<string, Notification>(); // message.id, Notification
  static NotificationsByRoom = new Map<string, Notification[]>(); // room.id, Notification
  static Notifications: Notification[] = [];
  static NotificationsUpdatedEmitter = new EventEmitter(); // 'updated'
  static NrOfNew = 0;
  static NrOfNewLastChange = 0;

  static setNotifications(notifs: Notification[], roomSettings: Map<string, RoomSetting>) {
    this.NotificationsByMessage.clear();
    this.NotificationsByRoom.clear();
    this.Notifications = notifs;
    let _nrOfNew = notifs.filter(n => n.isNew && (n.roomId ? !roomSettings.get(n.roomId)?.disablePushNotifications : true)).length;
    this.NrOfNewLastChange = _nrOfNew - this.NrOfNew;
    this.NrOfNew = _nrOfNew;

    notifs.forEach(n => {
      if (n.messageId) {
        this.NotificationsByMessage.set(n.messageId, n)
      }
      if (n.roomId) {
        if (!this.NotificationsByRoom.get(n.roomId)) {
          this.NotificationsByRoom.set(n.roomId, []);
        }
        this.NotificationsByRoom.get(n.roomId)?.push(n);
      }
    });
    this.NotificationsUpdatedEmitter.emit('updated', notifs);
  }

  static subscribeToNotificationUpdates(handler: (notifs: Notification[]) => void): () => void {
    MyNotifs.NotificationsUpdatedEmitter.on('updated', handler);
    handler(this.Notifications);
    return () => MyNotifs.NotificationsUpdatedEmitter.removeListener('updated', handler);
  }

}

MyNotifs.NotificationsUpdatedEmitter.setMaxListeners(100);


  // static getNrOfNewFromUser(userId: string, roomId: string) {
  //   return (this.NotificationsByUser.get(userId) ?? []).filter(n => n.messageId && n.isNew && n.roomId == roomId).length;
  // }